import TeamTable from "@/app/app-shared/team-table";

const Team = () => {
  return <TeamTable />;
};

export default Team;
